"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M9.551 17.4c4.981 0 7.706-4.155 7.706-7.759 0-.118 0-.235-.008-.352.53-.386.987-.864 1.351-1.412a5.376 5.376 0 01-1.556.43c.566-.342.989-.878 1.191-1.51a5.405 5.405 0 01-1.72.663 2.697 2.697 0 00-3.253-.537A2.736 2.736 0 0011.9 9.947a7.671 7.671 0 01-5.581-2.85 2.74 2.74 0 00.838 3.64 2.674 2.674 0 01-1.229-.34v.034c0 1.298.91 2.416 2.173 2.673-.399.11-.817.126-1.223.047a2.714 2.714 0 002.53 1.894 5.41 5.41 0 01-4.008 1.13 7.628 7.628 0 004.151 1.223" }), "Twitter");
//# sourceMappingURL=Twitter.js.map